/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Aug 01 2024
 **/

import { useRef } from "react";
import { EventEmitter } from "eventemitter3";

import { useStompClient, useStompManager } from ".";

const LOGTAG = "#useStompClientActions#";
export default function useStompClientActions() {
	const event = useRef(new EventEmitter());
	const stomp = useStompManager();

	useStompClient(
		{
			onConnected: () => {
				event.current.emit("$stomp::connected$");
			}
		},
		[]
	);

	return {
		waitForConnected: (): Promise<void> => {
			return new Promise<void>((resolve) => {
				if (stomp.isConnected) {
					console.debug(LOGTAG, "stomp already connected");
					resolve();
				}

				event.current.on("$stomp::connected$", () => {
					console.debug(LOGTAG, "stomp connected");
					resolve();
				});
			});
		}
	};
}
